import { ReactNode } from "react";
import { useTranslate } from "react-admin";
import { enumWalletType } from "../utils/constant";
import Tooltip from "@mui/material/Tooltip";
import { AddressBookIconData } from "./AddressBookSuggestion";
import { OperationSmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";

export default function WalletTypeIcon(props: {
  addressBookIconData: AddressBookIconData;
  isScrolling?: boolean;
  childElement?: ReactNode;
  walletTypeIconColorArr: string[];
}) {
  const translate = useTranslate();
  const {
    addressBookIconData,
    isScrolling,
    childElement,
    walletTypeIconColorArr,
  } = props;
  const t = (key: string) => translate(`walletManagement.${key}`);

  const walletTypeIconColorMapping = (walletType: number) => {
    const defaultColor = walletTypeIconColorArr[2];

    return walletTypeIconColorArr[walletType] || defaultColor;
  };

  const hasChild = childElement !== undefined;

  const isContractHotWallet = [
    OperationSmartAccountType.MultisignWallet,
    OperationSmartAccountType.MultisignWalletKernel,
    OperationSmartAccountType.MultisignWalletTronRentalEnergyBandwidth,
  ].includes(Number(addressBookIconData.smart_account_type));

  const getIconText = () => {
    if (isContractHotWallet) {
      return translate(`enumConstants.contractHotWalletIconText`);
    }

    return translate(
      `enumConstants.${enumWalletType[String(addressBookIconData.wallet_type)]}`
    )[0];
  };

  const iconText = getIconText();

  return (
    <Tooltip
      title={
        isScrolling ? (
          ""
        ) : (
          <>
            <div>
              {t("display_name")}: {addressBookIconData.display_name}
            </div>
            <div>
              {t("wallet_type")}:{" "}
              {translate(
                `enumConstants.${
                  enumWalletType[String(addressBookIconData.wallet_type)]
                }`
              )}
            </div>
          </>
        )
      }
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            margin: "0 8px",
            marginLeft: hasChild ? "0px" : "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: isContractHotWallet ? "8px" : "1rem",
            minWidth: "24px",
            maxWidth: "24px",
            minHeight: "24px",
            maxHeight: "24px",
            color: "#fff",
            borderRadius: "80%",
            cursor: "default",
            backgroundColor: walletTypeIconColorMapping(
              Number(addressBookIconData.wallet_type)
            ),
          }}
        >
          <div style={{ userSelect: "none" }}>{iconText}</div>
        </div>
        {childElement}
      </div>
    </Tooltip>
  );
}
